<script>
import TableBlock from '@/components/Analysis/TableBlockMixin';

export default {
  mixins: [TableBlock],

  computed: {
    computedData() {
      const { averageTime, collaboratorsByRegion, sites, filteredCollaborators } = this.data;
      const computedSites = this.range ? sites.slice(this.range[0], this.range[1]) : sites;
      let otherAverageTime = 0;
      const subHeader = {
        caption: this.$t('actualSites', this.data.actualSites.length),
        className: {
          big: true,
          'current-site-value': true,
        },
      };
      const superHeader = [
        {
          className: {
            big: true,
          },
        },
      ];
      const specifications = [subHeader];

      superHeader.push({
        caption: this.$t('mean'),
      });
      specifications.push({
        value: averageTime,
        sub: ' min',
        className: {
          'current-site-value': true,
        },
      });

      collaboratorsByRegion.slice(0, 4).forEach(region => {
        superHeader.push({
          caption: region.caption.length > 15 ? `${region.caption.slice(0, 12)}...` : region.caption,
          title: region.caption.length > 15 ? region.caption : null,
          value: region.percentage,
          sub: '%',
        });

        specifications.push({
          value: region.averageTime,
          sub: ' min',
          className: {
            'current-site-value': true,
          },
        });
      });

      const byRegionLength = collaboratorsByRegion.length;
      if (byRegionLength > 4) {
        let totalCount = 0;
        let totalTime = 0;
        collaboratorsByRegion.slice(4, byRegionLength).forEach(s => {
          totalCount = totalCount + s.count;
          totalTime = totalTime + s.count * s.averageTime;
        });

        superHeader.push({
          caption: this.$t('other'),
          value: collaboratorsByRegion.slice(4, byRegionLength).reduce((acc, region) => acc + region.percentage, 0) || 0,
          sub: '%',
        });

        otherAverageTime = totalTime / totalCount || 0;
        specifications.push({
          value: otherAverageTime,
          sub: ' min',
          className: {
            'current-site-value': true,
          },
        });
      }

      const entries = computedSites.map(site => {
        const result = [this.buildSiteBlock(site, filteredCollaborators, this.forcedTransport)];
        result.push(this.computeTrend(site.details.averageTimeDiff));

        const sortedCollaboratorsByRegion = site.details.collaboratorsByRegion.sort((a, b) => b.count - a.count);

        sortedCollaboratorsByRegion.slice(0, 4).forEach((item, idx) => {
          result.push(this.computeTrend(item.averageTime - collaboratorsByRegion[idx].averageTime));
        });

        let totalCount = 0;
        let totalTime = 0;
        sortedCollaboratorsByRegion.slice(4, sortedCollaboratorsByRegion.length).forEach(s => {
          totalCount = totalCount + s.count;
          totalTime = totalTime + s.count * s.averageTime;
        });

        if (sortedCollaboratorsByRegion.length > 4) {
          result.push(this.computeTrend(Math.round((totalTime / totalCount || 0) - otherAverageTime)));
        }

        return result;
      });

      return {
        data: {
          superHeader,
          specifications,
          entries,
          class: 'average',
        },
      };
    },
  },
};
</script>
